import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AppHistory from "shared/history"
import changeLocale from "components/users/change-locale"
import {dig} from "diggerize"
import HayaSelect from "components/woof-haya-select"
import Locales from "shared/locales"
import memo from "set-state-compare/build/memo"
import useCurrentUser from "@kaspernj/api-maker/build/use-current-user"
import useLocale from "i18n-on-steroids/build/src/use-locale.js"

/** @typedef {object} ComponentsFrontLayoutLocaleSelectProps */

/** @typedef {object} ComponentsFrontLayoutLocaleSelectState */

/**
 * @extends {ShapeComponent<ComponentsFrontLayoutLocaleSelectProps, ComponentsFrontLayoutLocaleSelectState>}
 */
class ComponentsFrontLayoutLocaleSelect extends ShapeComponent {
  setup() {
    this.currentUser = useCurrentUser()
    this.locale = useLocale()

    this.localeOptions = useMemo(() => {
      const options = []

      for (const locale of Locales.availableLocales()) {
        options.push({
          text: Locales.labelForLocale(locale),
          value: locale
        })
      }

      return options
    }, [this.locale])
  }

  render() {
    return (
      <HayaSelect
        id="locale_select"
        onChange={this.tt.onLocaleChanged}
        options={this.tt.localeOptions}
        values={[this.tt.locale]}
      />
    )
  }

  onLocaleChanged = async (args) => {
    if (!args) return

    const locale = dig(args, "options", 0, "value")

    if (!locale) return

    await changeLocale(locale)

    const url = new URL(location.href)

    url.searchParams.set("translate_url_to_current_locale", locale)

    try {
      const response = await fetch(url.href)

      if (!response.ok) {
        throw new Error(`Expected locale URL translation to return 2xx. Got: ${response.status}`)
      }

      const responseData = await response.json()

      AppHistory.replace(responseData.new_url)
    } catch (error) {
      console.error(error)
    }
  }
}

export default memo(shapeComponent(ComponentsFrontLayoutLocaleSelect))
